import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSDK } from '@metamask/sdk-react';
import { hexToNumberString } from '~/blockchain/provider';

const env = process.env.REACT_APP_NETWORK_ENV 

const AddNetwork = () => {
  const { sdk } = useSDK();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const networkConfigs = {
    development: {
      chainId: '0x4EE5', 
      chainName: 'Sand Verse - Testnet',
      rpcUrls: ['https://rpc.sandverse.oasys.games'],
      blockExplorerUrls: ['https://scan.sandverse.oasys.games/'],
      redirectUrl: 'https://test.remonster.world/',
    },
    staging: {
      chainId: '0x736C', 
      chainName: 'MCH Verse Mainnet',
      rpcUrls: ['https://rpc.oasys.mycryptoheroes.net'],
      blockExplorerUrls: ['https://explorer.oasys.games/'],
      redirectUrl: 'https://staging.remonster.world/',
    },
    production: {
      chainId: '0x736C', 
      chainName: 'MCH Verse Mainnet',
      rpcUrls: ['https://rpc.oasys.mycryptoheroes.net'],
      blockExplorerUrls: ['https://explorer.oasys.games/'],
      redirectUrl: 'https://beta.remonster.world/',
    },
  };

  const config = networkConfigs[env];

  const addNetworkToMetaMask = async () => {
    setIsLoading(true);
    setError(null);

    try {
      if (!sdk) {
        throw new Error('MetaMask SDK not initialized');
      }

      await sdk.connect();

      const provider = sdk.getProvider();
      if (!provider) {
        throw new Error('MetaMask provider is unavailable');
      }

      let currentNetworkId = await provider.request({
        method: 'eth_chainId',
        params: [],
      });
      currentNetworkId = hexToNumberString(currentNetworkId);

      if (parseInt(currentNetworkId) === parseInt(config.chainId, 16)) {
        console.log(`${config.chainName} already added!`);
        window.location.replace(config.redirectUrl);
        return;
      }

      await provider.request({
        method: 'wallet_addEthereumChain',
        params: [
          {
            chainId: config.chainId,
            chainName: config.chainName,
            nativeCurrency: {
              symbol: 'OAS',
              decimals: 18,
            },
            rpcUrls: config.rpcUrls,
            blockExplorerUrls: config.blockExplorerUrls,
          },
        ],
      });

      console.log(`${config.chainName} added successfully!`);
      window.location.replace(config.redirectUrl);
    } catch (error) {
      console.error('Error adding network:', error.message);
      setError(error.message);
      window.location.replace(config.redirectUrl); 
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <button
        onClick={addNetworkToMetaMask}
        disabled={isLoading}
        className={`px-6 py-3 text-white font-semibold rounded-lg shadow-md duration-300 
          ${isLoading ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'}`}
      >
        {isLoading ? 'Waiting...' : `Add ${config.chainName}`}
      </button>
      {error && <p className="mt-4 text-red-500">{error}</p>}
    </div>
  );
};

export default AddNetwork;